<template>
  <div class="suppression">
    <ak-field :label="`Import ${leadsTerm} as`" required>
      <template #helper>
        <div class="text-small mb-small">
          {{ leadsTerm }} flagged as Suppressed will be added to a Global
          Suppression list and will not receive any non-transactional emails
          from your account
        </div>
      </template>
      <ak-radio-group
        v-model="operation.configuration.suppressed"
        :options="suppressionOptions"
        required
      />
    </ak-field>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'

export default defineComponent({
  name: 'AkIntegrationSFTPCreateLeadSuppression',
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const leadsTerm = entityBranding('leads.plural', 'Leads')

    /**
     * Operation configuration
     * @type {RefTypes.ComputedRef<*>}
     */
    const operation = props.service.getOperation()

    /**
     * Suppression options
     * @type {[{label: string, value: boolean},{label: string, value: boolean}]}
     */
    const suppressionOptions = [
      {
        label: 'Not Suppressed',
        value: false,
      },
      {
        label: 'Suppressed',
        value: true,
      },
    ]

    return {
      leadsTerm,
      operation,
      suppressionOptions,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@akerolabs/akero-vue/src/scss/_settings.scss';

.suppression .ak-radio-group {
  gap: $spacing-small;
}
</style>
